var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLearningoutcomes24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "highlight-24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home-\\u6CA1\\u6709list",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assessments-unpublished",
    transform: "translate(-1097.000000, -125.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "highlight-24px",
    transform: "translate(1097.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,14 L9,17 L9,22 L15,22 L15,17 L18,14 L18,9 L6,9 L6,14 Z M8,11 L16,11 L16,13.17 L13,16.17 L13,20 L11,20 L11,16.17 L8,13.17 L8,11 Z M11,2 L13,2 L13,5 L11,5 L11,2 Z M3.502,5.874 L4.916,4.46 L7.038,6.58 L5.624,7.995 L3.502,5.874 Z M16.96,6.582 L19.083,4.462 L20.496,5.878 L18.373,7.998 L16.96,6.582 Z",
    id: "\\u5F62\\u72B6",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningoutcomes24Px);
export default __webpack_public_path__ + "static/media/learning outcomes-24px.4c625e73.svg";
export { ForwardRef as ReactComponent };